import { render, staticRenderFns } from "./trainVetInner.vue?vue&type=template&id=28b59d73&scoped=true&"
import script from "./trainVetInner.vue?vue&type=script&lang=js&"
export * from "./trainVetInner.vue?vue&type=script&lang=js&"
import style0 from "./trainVetInner.vue?vue&type=style&index=0&id=28b59d73&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28b59d73",
  null
  
)

export default component.exports